module.exports = "<svg id=\"9e30865b-1a84-4b37-a99e-0f70d1479a18\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>instagram</title><circle class=\"icon-background\" cx=\"25\" cy=\"25\" r=\"24.5\"></circle><rect class=\"icon-fill\" x=\"10.5\" y=\"9.5\" width=\"29\" height=\"29\" rx=\"6.84\" ry=\"6.84\"></rect><circle class=\"icon-fill-2\" cx=\"25\" cy=\"25\" r=\"6.4\"></circle><circle class=\"icon-fill\" cx=\"25\" cy=\"25\" r=\"3.4\"></circle><circle class=\"icon-fill-2\" cx=\"32.08\" cy=\"16.24\" r=\"2.02\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 484
// module chunks = 1